const Airtable = require("airtable");

Airtable.configure({
  endpointUrl: "https://api.airtable.com",
  apiKey:
    "patdgNjooJ4TOVPzB.ba8008a3e77fb0048d06d29125a3c821ad86ea02d273e3629a6d8af21a583790",
});

export const airtableBase = Airtable.base("appHwPE6kjv8rYDXv");
